import { Card } from 'antd'
import { useState } from 'react';
import TabContent from './TabContent/index';

const PromotionalTabs = ({ products }) => {
    const [activeTabKey, setActiveTabKey] = useState('offers');

    const offerTabsList = {
        offers: <TabContent products={products} />,
        recent: <TabContent products={products} />,
    }

    return (
        <Card
            style={{
                borderRadius: '12px',
                boxShadow: '0 4px 10px rgba(0,0,0,0.04)',
            }}
            className="w-full h-full flex-1"
            classNames={{ header: 'pb-0', body: 'p-0 pt-2' }}
            tabList={[
                { key: 'offers', tab: 'Offers' },
                { key: 'recent', tab: 'Recent Purchases' },
            ]}
            activeTabKey={activeTabKey}
            onTabChange={(key) => setActiveTabKey(key)}
            tabProps={{
                size: 'small',
                type: 'card',
            }}
        >
            {offerTabsList[activeTabKey]}
        </Card>)
}

export default PromotionalTabs